export default "__VITE_ASSET__CSx0zwoe__"